module.exports = __webpack_public_path__ + "images/feature/emoji-7bd7ab1099df2e4ddcabf9e33af83e28.png";